import loadable from "@loadable/component";

loadable.lib(
  () => import(/* webpackChunkName: "map" */"@ct-react/map"),
  { ssr: false });

loadable(
  // @ts-ignore
  () => import(/* webpackChunkName: "map" */"./index.scss"),
  { ssr: false });

export const MapContainer = loadable(
  () => import(/* webpackChunkName: "map" */"./container-wrapper"),
  { ssr: false });

export const MapMarker = loadable(
  () => import(/* webpackChunkName: "map" */"@ct-react/map"),
  { ssr: false, resolveComponent: m => m.Marker });

export const MapPopup = loadable(
  () => import(/* webpackChunkName: "map" */"@ct-react/map"),
  { ssr: false, resolveComponent: m => m.Popup });

export const MapAsyncPopupMarker = loadable(
  () => import(/* webpackChunkName: "map" */"./async-popup-marker"),
  { ssr: false });
